import { render } from "./index.vue?vue&type=template&id=20198635"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=20198635&lang=less"

import exportComponent from "/Users/qianlong/Documents/Code/entertainment-and-catering-h5/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__